import { Modal } from 'bootstrap';
import axios from 'axios';
import swal from 'sweetalert';

window.culligan = window.culligan || {};

let chatgptSummary;

window.culligan.openChatGPTSummaryModal = async function(postId) {
  const modalEl = document.querySelector('#modal-chatgpt-summary');
  const modal = new Modal(modalEl);

  // Use cached summary if available.
  if (chatgptSummary) {
    modalEl.querySelector('.chatgpt-summary-content').innerHTML = chatgptSummary;
    modal.show();
    return;
  }

  modal.show();
  const params = new URLSearchParams();
  params.append('action', 'load_chatgpt_summary');
  params.append('post_id', postId);

  try {
    const resp = await axios.post(ajaxurl, params);
    if (resp.data.summary) {

      // Cache the summary
      chatgptSummary = resp.data.summary;

      modalEl.querySelector('.chatgpt-summary-content').innerHTML = chatgptSummary;
    }

  } catch(err) {
    swal('', 'An unexpected error occurred.', 'error');
  }
};
